import { render } from "./FrontFooter.vue?vue&type=template&id=bf2f1268"
const script = {}

import "./FrontFooter.vue?vue&type=style&index=0&id=bf2f1268&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__